module.exports = __webpack_public_path__ + "img/htcm_01.63ebeb1a.jpg";